<template>
  <div class="h-pm-alarm-tree">
    <ejs-treeview ref="pmAlarmQueryTree" :fields="fieldsOfPmAlarmQueryTree" :nodeSelected='nodeSelectedOfPmAlarmQueryTree'></ejs-treeview>
  </div>
</template>

<script>
    export default {
      name: "PmAlarmQueryLeftTree",
      data(){
        return {
          fieldsOfPmAlarmQueryTree: {
            dataSource: [{ children: [] }],
            id: 'id',
            text: 'text',
            child: 'children',
            expanded: 'state',
            tooltip: 'text',
            htmlAttributes: 'attributes'
          }
        }
      },
      methods: {
        getPmAlarmQueryTree() {
          this.$axios.get('/lte/ems/pm/alarmManagement/buildPmAlarmQueryTree.html').then((response) => {
            this.fieldsOfPmAlarmQueryTree = {
              dataSource: response.data,
              id: 'id',
              text: 'text',
              child: 'children',
              expanded: 'state'
            };
          });
        },
        nodeSelectedOfPmAlarmQueryTree(node){
          this.$emit('nodeSelectedOfPmAlarmQueryTree', node);
        }
      },
      mounted() {
        this.getPmAlarmQueryTree();
      }
    }
</script>

<style scoped>

</style>
